import React, {
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { withStripes } from '@folio/stripes/core';
import { NoValue } from '@folio/stripes/components';

import { openItemDetail } from '../../../../utils';
import { SearchAndFilter } from '../../../../components/common';
import { TEAM_FIELDS } from '../../../../constants';

const resultsPaneTitle = (
  <span data-test-teams-title>
    <FormattedMessage id="ui-task-list.title.list.teams" />
  </span>
);

const visibleColumns = [
  TEAM_FIELDS.NAME,
  TEAM_FIELDS.MEMBERS,
  TEAM_FIELDS.TOTAL_TASKS,
];

const columnMapping = {
  [TEAM_FIELDS.NAME]: <FormattedMessage id="ui-task-list.team.field.name" />,
  [TEAM_FIELDS.MEMBERS]: <FormattedMessage id="ui-task-list.team.field.totalMembers" />,
  [TEAM_FIELDS.TOTAL_TASKS]: <FormattedMessage id="ui-task-list.team.field.totalTasks" />,
};

const resultsFormatter = {
  [TEAM_FIELDS.NAME]: data => data[TEAM_FIELDS.NAME],
  [TEAM_FIELDS.MEMBERS]: data => (data[TEAM_FIELDS.MEMBERS] ? data[TEAM_FIELDS.MEMBERS].length : <NoValue />),
  [TEAM_FIELDS.TOTAL_TASKS]: data => (data[TEAM_FIELDS.TOTAL_TASKS] ? data[TEAM_FIELDS.TOTAL_TASKS] : <NoValue />),
};

const TeamList = ({
  history,
  match,
  isLoading,
  location,
  onNeedMoreData,
  resetData,
  teams,
  teamsCount,
  children,
  stripes,
}) => {
  const hasEditCreatePermission = stripes.hasPerm('ui-task-list.teams.create-edit');

  const openTeamDetails = useCallback(
    (e, meta) => {
      openItemDetail({
        path: match.path,
        id: meta.id,
        history,
        location,
      });
    },
    [location.search],
  );

  return (
    <SearchAndFilter
      isInsideListSearch
      isPreRenderAllData
      columnMapping={columnMapping}
      contentData={teams}
      count={teamsCount}
      id="teams-list"
      isLoading={isLoading}
      isShowAddNew={hasEditCreatePermission}
      resetData={resetData}
      resultsFormatter={resultsFormatter}
      resultsPaneTitle={resultsPaneTitle}
      visibleColumns={visibleColumns}
      onNeedMoreData={onNeedMoreData}
      onRowClick={openTeamDetails}
    >
      {children}
    </SearchAndFilter>
  );
};

TeamList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  resetData: PropTypes.func.isRequired,
  stripes: PropTypes.shape({
    hasPerm: PropTypes.func.isRequired,
  }).isRequired,
  onNeedMoreData: PropTypes.func.isRequired,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  teams: PropTypes.arrayOf(PropTypes.object),
  teamsCount: PropTypes.number,
};

TeamList.defaultProps = {
  teamsCount: 0,
  isLoading: false,
  teams: [],
};

export default withRouter(withStripes(TeamList));
